import { render, staticRenderFns } from "./shopAdd.vue?vue&type=template&id=385a9982&scoped=true"
import script from "./shopAdd.vue?vue&type=script&lang=js"
export * from "./shopAdd.vue?vue&type=script&lang=js"
import style0 from "./shopAdd.vue?vue&type=style&index=0&id=385a9982&lang=scss&scoped=true"
import style1 from "./shopAdd.vue?vue&type=style&index=1&id=385a9982&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385a9982",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('385a9982')) {
      api.createRecord('385a9982', component.options)
    } else {
      api.reload('385a9982', component.options)
    }
    module.hot.accept("./shopAdd.vue?vue&type=template&id=385a9982&scoped=true", function () {
      api.rerender('385a9982', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/inflowShopManagement/shopList/shopAdd.vue"
export default component.exports